// extracted by mini-css-extract-plugin
module.exports = {"pagination":"styles_pagination__g6lks","contentBox":"styles_contentBox__2TFzD","paginationButton":"styles_paginationButton__27w1D","boxWidth":"styles_boxWidth__j-Urv"};